import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class BusinessVerificationApiErrorCode extends BaseModel {
  static BusinessVerificationApiErrorCodeProperties: (
    | {
        property: keyof BusinessVerificationApiErrorCode;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof BusinessVerificationApiErrorCode;
        type: 'alias';
      }
    | {
        property: keyof BusinessVerificationApiErrorCode;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    {
      property: 'BusinessVerificationApiErrorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'httpStatusCode', type: 'column', dataType: 'string' },
    { property: 'code', type: 'column', dataType: 'string' },
    { property: 'serviceName', type: 'column', dataType: 'string' },
    { property: 'type', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    BusinessVerificationApiErrorCode.BusinessVerificationApiErrorCodeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          BusinessVerificationApiErrorCode.columnMap.set(
            property,
            propertyObject
          );
        }
        if (type === 'alias') {
          BusinessVerificationApiErrorCode.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          BusinessVerificationApiErrorCode.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    BusinessVerificationApiErrorCodeObject: Partial<BusinessVerificationApiErrorCode>
  ) {
    super();

    BusinessVerificationApiErrorCode.BusinessVerificationApiErrorCodeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = BusinessVerificationApiErrorCodeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  BusinessVerificationApiErrorId?: number;
  httpStatusCode?: string;
  code?: string | null;
  type?: 'Authorization' | 'Data';
  serviceName?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
}
